import clsx from 'clsx';
import { DefaultButton, colors } from 'design-system';
import { makeStyles, createStyles, Grid, Typography } from '@material-ui/core';

const useStyles = makeStyles(() =>
  createStyles({
    titleText: {
      fontSize: '19px',
      fontWeight: 900,
      marginBottom: '20px',
    },
    infoText: {
      fontSize: '17px',
      fontWeight: 400,
      color: colors.abbey,
      marginBottom: '20px',
    },
    supportText: {
      fontSize: '15px',
      fontWeight: 400,
      color: colors.abbey,
    },
    email: {
      textDecoration: 'underline',
    },
    buttonSpace: {
      marginTop: '40px',
      marginBottom: '25px',
    },
  }),
);

type Props = {
  onReload: () => void;
  finishTime: string;
};

const DesktopMaintenanceLayout = ({
  onReload,
  finishTime,
}: Props): JSX.Element => {
  const classes = useStyles();
  return (
    <Grid container justifyContent="center" alignItems="center">
      <Grid item xs={12}>
        <Typography className={classes.titleText} align="center">
          Nos encontramos en <br /> mantenimiento
        </Typography>
      </Grid>

      <Grid item xs={12}>
        <Typography className={classes.infoText} align="center">
          Estaremos de regresos a las {` ${finishTime}`}
        </Typography>
      </Grid>

      <Grid item xs={12} container justifyContent="center">
        <img
          alt="maintenance-figure"
          src="/svg/maintenance-figure.svg"
          width={300}
        />{' '}
      </Grid>

      <Grid
        item
        xs={12}
        container
        justifyContent="center"
        className={classes.buttonSpace}
      >
        <DefaultButton
          data-testid="personalize-button"
          variant="outlined"
          onClick={onReload}
        >
          refrescar página
        </DefaultButton>
      </Grid>

      <Grid item xs={12}>
        <Typography className={classes.supportText} align="center">
          Para consultas contacta a soporte técnico:
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography
          className={clsx(classes.email, classes.supportText)}
          align="center"
        >
          soporteventasautocr@assanet.com
        </Typography>
      </Grid>
    </Grid>
  );
};

export default DesktopMaintenanceLayout;
